import { pxToRem, imageClassName } from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';

export const PrimaryImageDesktopContainer: StyleRule<{
    width: number;
    height: number;
    isVideo: boolean;
    isVideoError: boolean;
    fluid?: boolean;
}> = ({ theme, width, height, isVideo, isVideoError, fluid }) => ({
    width: fluid ? '100%' : pxToRem(width),
    height: pxToRem(height),
    margin: `0 auto`,
    display: 'block',
    maxWidth: '100%',
    position: 'relative',
    borderRadius: pxToRem(10),
    overflow: 'hidden',

    [`& .${imageClassName}`]: {
        height: '100%',
        '& img': {
            backgroundColor: isVideo
                ? isVideoError
                    ? theme.siteVariables.colors.white['200A']
                    : theme.siteVariables.colors.primitive.black
                : 'transparent',
            height: '100%',
        },
    },
    [theme.screen.tablet]: {
        display: 'block',
    },
});

export const ImageCaption: StyleRule = () => ({ textAlign: 'center' });
